module.exports = __webpack_public_path__ + "img/top-background@2x.820d9b59.png";